/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Timeline_EyebrowInputs */

const en_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moments`)
};

const es_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momentos`)
};

const de_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momente`)
};

const zh_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精彩瞬间`)
};

const ar_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لحظات`)
};

const fr_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moments`)
};

const vi_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoảnh khắc`)
};

const sw_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matukio`)
};

const th_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ช่วงเวลา`)
};

const bs_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenuci`)
};

const ja_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モーメント`)
};

const ko_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`순간`)
};

const pt_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momentos`)
};

const it_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momenti`)
};

const sv_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ögonblick`)
};

const nl_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momenten`)
};

const da_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Øjeblikke`)
};

const nb_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Øyeblikk`)
};

const fi_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hetket`)
};

const pl_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chwile`)
};

const ru_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моменты`)
};

const tr_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlar`)
};

const hi_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्षण`)
};

const id_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momen`)
};

const ms_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momen`)
};

const cs_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momenty`)
};

const el_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Στιγμές`)
};

const he_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רגעים`)
};

const af_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momente`)
};

const hu_hof_timeline_eyebrow = /** @type {(inputs: Hof_Timeline_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pillanatok`)
};

/**
* | output |
* | --- |
* | "Moments" |
*
* @param {Hof_Timeline_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_timeline_eyebrow = /** @type {((inputs?: Hof_Timeline_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Timeline_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_timeline_eyebrow(inputs)
	if (locale === "de") return de_hof_timeline_eyebrow(inputs)
	if (locale === "zh") return zh_hof_timeline_eyebrow(inputs)
	if (locale === "ar") return ar_hof_timeline_eyebrow(inputs)
	if (locale === "fr") return fr_hof_timeline_eyebrow(inputs)
	if (locale === "vi") return vi_hof_timeline_eyebrow(inputs)
	if (locale === "sw") return sw_hof_timeline_eyebrow(inputs)
	if (locale === "th") return th_hof_timeline_eyebrow(inputs)
	if (locale === "bs") return bs_hof_timeline_eyebrow(inputs)
	if (locale === "ja") return ja_hof_timeline_eyebrow(inputs)
	if (locale === "ko") return ko_hof_timeline_eyebrow(inputs)
	if (locale === "pt") return pt_hof_timeline_eyebrow(inputs)
	if (locale === "it") return it_hof_timeline_eyebrow(inputs)
	if (locale === "sv") return sv_hof_timeline_eyebrow(inputs)
	if (locale === "nl") return nl_hof_timeline_eyebrow(inputs)
	if (locale === "da") return da_hof_timeline_eyebrow(inputs)
	if (locale === "nb") return nb_hof_timeline_eyebrow(inputs)
	if (locale === "fi") return fi_hof_timeline_eyebrow(inputs)
	if (locale === "pl") return pl_hof_timeline_eyebrow(inputs)
	if (locale === "ru") return ru_hof_timeline_eyebrow(inputs)
	if (locale === "tr") return tr_hof_timeline_eyebrow(inputs)
	if (locale === "hi") return hi_hof_timeline_eyebrow(inputs)
	if (locale === "id") return id_hof_timeline_eyebrow(inputs)
	if (locale === "ms") return ms_hof_timeline_eyebrow(inputs)
	if (locale === "cs") return cs_hof_timeline_eyebrow(inputs)
	if (locale === "el") return el_hof_timeline_eyebrow(inputs)
	if (locale === "he") return he_hof_timeline_eyebrow(inputs)
	if (locale === "af") return af_hof_timeline_eyebrow(inputs)
	if (locale === "hu") return hu_hof_timeline_eyebrow(inputs)
	return en_hof_timeline_eyebrow(inputs)
});